import { TechSpecIdentifier } from "@bluframe/mightychroma-mightytool-frontend-types"

const techSpecs = [
  ["VideoResolution2160P" as TechSpecIdentifier.VIDEO_RESOLUTION_2160P],
  ["VideoSourceNative4K" as TechSpecIdentifier.VIDEO_SOURCE_NATIVE_4K],
  ["VideoHDRTypeDolbyVision" as TechSpecIdentifier.VIDEO_HDR_TYPE_DOLBY_VISION],
  ["VideoHDRTypeHDR10" as TechSpecIdentifier.VIDEO_HDR_TYPE_HDR10],
  [
    "AudioLanguageEnglish" as TechSpecIdentifier.AUDIO_LANGUAGE_ENGLISH,
    "AudioFormatDTS:X" as TechSpecIdentifier.AUDIO_FORMAT_DTS_X
  ],
  ["PackagingCaseSlipcover" as TechSpecIdentifier.PACKAGING_CASE_SLIPCOVER],
  ["DigitalCopy4K" as TechSpecIdentifier.DIGITAL_COPY_4K],
  ["DiscsFormat4KUltraHD" as TechSpecIdentifier.DISCS_FORMAT_4K_ULTRA_HD],
  ["SubtitlesLanguageEnglish" as TechSpecIdentifier.SUBTITLES_LANGUAGE_ENGLISH]
]

export default techSpecs
